import { createFeatureSelector, createSelector } from '@ngrx/store';
import {
  ReservationSearchHistoryState,
  reservationSearchHistoryAdapter,
  reservationSearchHistoryFeatureKey,
} from './reservation-search-history.state';

/**
 * Extracts entity selectors from the adapter for use in custom selectors.
   - confirmationCodes: selector for all reservation IDs (confirmation codes)
   - reservationEntities: selector for the dictionary of reservation entities
 */
const { selectIds: confirmationCodes, selectEntities: reservationEntities } = reservationSearchHistoryAdapter.getSelectors();

export class ReservationSearchHistorySelectors {
  /**
   * Gets the reservation search history state from the root state.
   */
  static readonly getReservationSearchHistoryState =
    createFeatureSelector<ReservationSearchHistoryState>(reservationSearchHistoryFeatureKey);

  /**
   * Gets the dictionary of reservation entities from the search history state
   */
  static readonly getReservationsFromSearchHistory = createSelector(
    ReservationSearchHistorySelectors.getReservationSearchHistoryState,
    reservationEntities
  );

  /**
   * Gets the list of all confirmation codes from the search history state
   */
  static readonly getConfirmationCodes = createSelector(
    ReservationSearchHistorySelectors.getReservationSearchHistoryState,
    confirmationCodes
  );

  /**
   * Given a confirmation code, selects the list of passenger full names for that reservation
   */
  static readonly getPassengerNamesFromPnrHistory = (confirmationCode: string) =>
    createSelector(ReservationSearchHistorySelectors.getReservationsFromSearchHistory, (reservations) =>
      reservations[confirmationCode]?.passengers?.map((passenger) => `${passenger.firstName} ${passenger.lastName}`)
    );
}
